module.exports = __webpack_public_path__ + "img/logo-b.b8252946.png";